import { Component, OnInit, Input, Directive, ViewChildren, QueryList, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { MainStepComponent } from './steps/main-step/main-step.component';
import { RxComponent } from 'app/core/components/common/rx.component';
import { RequestService } from 'app/core/services/request.service';

export class StepResult {
  id: string;
  title: string;
}


@Component({
  selector: 'itpx-catalog-modal',
  templateUrl: './catalog-modal.component.html',
  styleUrls: ['./catalog-modal.component.css']
})
export class CatalogModalComponent extends RxComponent implements OnInit {
  @ViewChildren('steps') cellTemplates: QueryList<TemplateRef<any>>;


  @Input() data;
  templates = {};
  templateKey;
  firstStepData: any[];
  firstStepSkipped = false;

  private stepResults: StepResult[] = [];


  constructor(private modalService: SmartModalService, private cd: ChangeDetectorRef, private requestService: RequestService) { super() }

  ngOnInit() {
    for (let i = 0; i < this.data.steps.length; i++) {
      this.stepResults.push(null);
    }
    this.requestService.get(this.data.steps[0].url).bindToLifecycle(this).subscribe(res => {
      if (res.data) {
        if (res.data.length > 1) {
          this.firstStepData = res.data;
          this.templateKey = this.data.steps[0].name;
        }
        else if (res.data.length === 1) {
          this.stepResults[0] = { id: res.data[0].code, title: res.data[0].name } as StepResult;
          this.firstStepSkipped = true;
          this.templateKey = this.data.steps[1].name;
        }
        else {
          this.modalService.close()
        }
      }
    })
  }
  ngAfterViewInit() {
    let cellTemplatesArray = this.cellTemplates.toArray();
    for (let i = 0; i < this.data.steps.length; i++) {
      this.templates[this.data.steps[i].name] = cellTemplatesArray[i];
    }
  }
  back(to) {
    this.templateKey = this.data.steps[to.to].name;
    for (let i = to.to; i < this.stepResults.length; i++) {
      this.stepResults[i] = null;
    }

  }

  saveProceed(e: StepResult, i: number) {
    this.stepResults[i] = e;
    this.templateKey = this.data.steps[i + 1].name;
  }

  onCancel() {
    this.modalService.close();
  }
  getResultsForStep(stepIndex: number) {
    return this.stepResults.slice(0, stepIndex);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal/catalog-modal/catalog-modal.component.ts